// extracted by mini-css-extract-plugin
export default {"page_wrapper":"Docs_page_wrapper__k2GdG","content_wrapper":"Docs_content_wrapper__5vstF","section_wrapper":"Docs_section_wrapper__RBFT3","docs_img":"Docs_docs_img__uXqtV"};